import React, { useEffect, useState } from 'react';
import { Layout } from 'tea-component';
import {
  FilterFixed,
  useFilterDataHook,
} from '@/pages/opinion/components/FilterCommon';
import '@/pages/opinion/assets/scss/pages/stats/channel.scss';
import { connect, useDispatch } from 'umi';
import CardLoading from '@/pages/opinion/components/CardLoading';
import GameStore from '../../Performance/components/GameStore';
import useLanguage from '@/pages/opinion/hooks/useLanguage';
import ChartsBox from '../components/ChartsBox';
import { useInitBuriedPointInfo } from '@/pages/opinion/operationLog/buriedPoint';
import StatsChannelPoint from '@op/operationLog/pages/statsChannel';
import ContentBody from '@/pages/opinion/components/ContentBody';
import { PAGE_NAME } from '@op/constants/page';
import DetailPageTable, { ChannelType } from '@op/components/DetailPageTable';
const { Content } = Layout; 

function Channel({ gameInfo, channel, channelLoading, wholeGameInfo }: any) {
  useInitBuriedPointInfo({ buriedPoint: StatsChannelPoint });
  const {
    loading,
    filter,
    changeFilter,
    filterOptions,
    scrollBody,
    topicList,
    changeTopicList,
  } = useFilterDataHook({
    gameInfo,
    pageName: 'Stats_Channel',
  });
  const [channelType, setChannelType] = useState<ChannelType>('social');
  const { formatMessage } = useLanguage();
  const dispatch = useDispatch();
  useEffect(() => {
    if (!gameInfo || !filter) return;
    dispatch({
      type: 'opinionPerformance/getOverviewChannel',
      payload: {
        ...filter,
        ...gameInfo,
        statistics_field: 'channel',
      },
    });
  }, [gameInfo, filter]);

  return (
    <Content className="dbo-channel" ref={scrollBody}>
      <ContentBody
        pageName={PAGE_NAME.CHANNEL}
        contentHeard={
          <Content.Header title={formatMessage({ id: PAGE_NAME.CHANNEL })} />
        }
      >
        <FilterFixed
          filter={filterOptions}
          scrollBody={scrollBody}
          confirm={(value: any) => {
            changeFilter({...value, ...gameInfo});
          }}
          backCondOriginData={(value) => {
            changeTopicList({ topic_trans: value.topic_trans, key_topic: {} });
          }}
        ></FilterFixed>
        <CardLoading loading={loading}>
          <GameStore filter={filter} />
          <ChartsBox
            data={channel}
            loading={channelLoading}
            filter={filter}
            dataType="channel"
          ></ChartsBox>
          <DetailPageTable
            hasNews={true}
            channelType={channelType}
            setChannelType={setChannelType}
            gameInfo={gameInfo}
            defaultPageInfo={{ page: 1, page_size: 5 }}
            filter={filter}
            hasPageable={false}
            wholeGameInfo={wholeGameInfo}
          ></DetailPageTable>
        </CardLoading>
      </ContentBody>
    </Content>
  );
}

export default connect((state: any) => {
  const { loading, opinionCommon, opinionPerformance } = state;

  return {
    gameInfo: opinionCommon.gameInfo,
    wholeGameInfo: opinionCommon.wholeGameInfo,

    channel: opinionPerformance.channel,
    channelLoading: loading.effects['opinionPerformance/getOverviewChannel'],
  };
})(Channel);
